/* eslint-disable */
import PropTypes from 'prop-types';
import { useState, useEffect, useMemo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './TablaBitacoraNotificacion.scss';
import { Table, Input, SelectTamanoPagina } from 'components';
import { message, DatePicker } from 'antd';
import {
  obtenRegistrosBitacoraNotificacion,
  downloadExcelBitacoraNotificacion
} from 'actions/bitacoraNotificacion.actions';
import { generateId } from 'utils/idGenerator';
import * as types from 'constants/bitacoraNotificacionActionTypes';
import { selectBitacoraNotificacionState } from 'selectors/bitacoraNotificacion.selector';
import { base64toBlob } from 'utils/file';
import { useDebounce } from 'hooks/useDebounce';
import { filterList } from 'utils/filterList';
import { REGULAR_DATE_FORMAT } from 'constants/dateFormat';

const DEBOUNCE_TIME_FILTER = 1000;

export const TablaBitacoraNotificacion = ({ mainFilters, pagination, setPagination }) => {
  const { loading, data } = useSelector(selectBitacoraNotificacionState);
  const [downloadingExcel, setDownloadingExcel] = useState(true);
  const [messageApi,, contextHolder] = message.useMessage();
  const dispatch = useDispatch();
  const [totalN, setTotalN] = useState(0);
  const [filters, setFilters] = useState({});
  const applyFilter = useDebounce((fields) => setFilters(fields), DEBOUNCE_TIME_FILTER);
  const filtersRef = useRef({});

  const handleDownloadExcel = async () => {
    try {
      setDownloadingExcel(true);

      if (mainFilters) {
        const { success, response } = await dispatch(
          downloadExcelBitacoraNotificacion(mainFilters)
        );

        if (success && response?.data.code === 200 && response.data.excel64) {
          const url = window.URL.createObjectURL(
            base64toBlob(response.data.excel64.base64, response.data.excel64.tipo)
          );
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', response.data.excel64.nombre);
          link.click();
        } else {
          /* empty */
        }
      } else {
        /* empty */
        console.log(messageApi);
      }
    } catch (error) {
      /* empty */
      // console.error('Error al consultar la bitácora de Notificación: ', error);
    } finally {
      setDownloadingExcel(false);
    }
  };

  const handleChangeFilter = ({ target }) => {
    const { value, name } = target;
    filtersRef.current[name] = value;
    applyFilter({ ...filtersRef.current });
  };

  const handleChangeDateFilter = (date) => {
    filtersRef.current.fechaHora = date;
    applyFilter({ ...filtersRef.current });
  };

  const filter = (columnName, lblColumn) => (
    <label htmlFor={columnName}>
      {lblColumn}
      <Input
        id={columnName}
        placeholder="Escribe"
        name={columnName}
        key={columnName}
        onChange={handleChangeFilter}
      />
    </label>
  );

  const filterDate = (columnName, lblColumn) => ( 
    <label htmlFor={columnName}>
      {lblColumn}
      <DatePicker
        id={columnName}
        name={columnName}
        key={columnName}
        placeholder="Escribe"
        style={{ width: '100%' }}
        allowClear
        onChange={handleChangeDateFilter}
        format={REGULAR_DATE_FORMAT}
      />
    </label>
  );

  const dataList = useMemo(() => {
    const listaFiltrada = filterList(data, filters);
    return listaFiltrada;
  }, [data, filters]);

  const handleChangePageSize = (pageSize) => {
    setPagination((prevPagination) => ({ ...prevPagination, pageSize, current: 1 }));
  };

  const obtenRegBitacoraNotificacion = async () => {
    try {
      const { success, totalNotificaciones, totalNotificacionesPagina } = await dispatch(
        obtenRegistrosBitacoraNotificacion(mainFilters, pagination.pageSize, pagination.current)
      );

      if (success && totalNotificaciones > 0 && totalNotificacionesPagina > 0) {
        setPagination((prev) => ({
          ...prev,
          total: totalNotificaciones
        }));

        setTotalN(totalNotificaciones);
        setDownloadingExcel(false);
      } else if (success && totalNotificaciones > 0 && totalNotificacionesPagina === 0) {
          setPagination((prev) => ({
          ...prev,
          current: 1, 
          total: 0
        }));

        setTotalN(0);
        setDownloadingExcel(false);
      }
      else if (totalNotificaciones === null || totalNotificaciones === 0) {
        setTotalN(0);
         setDownloadingExcel(true);
      }
    } catch (error) {
      console.log('Error', error);
    }
  };

  useEffect(() => {
    if (
      mainFilters.idProcesoElectoral !== undefined &&
      mainFilters.idProcesoElectoral !== null &&
      mainFilters.idProcesoElectoral !== '' &&
      mainFilters.idAmbito !== undefined &&
      mainFilters.idAmbito !== null &&
      mainFilters.idAmbito !== ''
    ) {
      obtenRegBitacoraNotificacion();
    } else {
      // Se realiza limpieza de la tabla cuando el usuario se mueve a otro módulo ya que los filtros se encuentra vacíos.
      setTotalN(0);
      const payload = [];
      dispatch({ type: types.REG_BITACORA_NOTIF_SUCCESS, payload });
    }
  }, [pagination.current, pagination.pageSize, mainFilters]);

  const columns = [
    {
      title: 'Asociado',
      dataIndex: 'asociado',
      width: '10%',
      align: 'center',
      key: 'asociado'
    },
    {
      title: 'Monitoreo',
      dataIndex: 'tipoActa',
      width: '8%',
      align: 'center',      
      key: 'tipoActa'
    },
    {
      title: 'A notificar',
      dataIndex: 'aNotificar',
      width: '9%',
      align: 'center',      
      key: 'aNotificar'
    },
    {
      title: 'Notificados anteriores',
      dataIndex: 'notificadosAnteriores',
      width: '10%',
      align: 'center',      
      key: 'notificadosAnteriores'
    },
    {
      title: 'Notificados',
      dataIndex: 'notificados',
      width: 'auto',
      align: 'center',      
      key: 'notificados'
    },
    {
      title: 'Correos', 
      dataIndex: 'correos',
      width: 'auto',
      align: 'center',      
      key: 'correos'
    },
    {
      title: 'Fecha y hora de envío',
      dataIndex: 'fechaHoraEnvioCadena',
      width: 'auto',
      align: 'center',      
      key: 'fechaHoraEnvioCadena'
    },
    {
      title: 'Nombre', 
      dataIndex: 'nombre',
      width: 'auto',
      align: 'center',      
      key: 'nombre'
    },
    {
      title: 'Sujeto obligado', 
      dataIndex: 'sujetoObligado',
      width: 'auto',
      align: 'center',      
      key: 'sujetoObligado'
    },
    {
      title: 'Usuario',
      dataIndex: 'usuario',
      width: 'auto',
      align: 'center',      
      key: 'usuario'
    },
    {
      title: 'Fecha y hora de registro', 
      dataIndex: 'fechaHoraCadena',
      width: 'auto',
      align: 'center',      
      key: 'fechaHoraCadena'
    }
  ];

  return (
    <div className="tabla-bitacora-notificacion">
      <div className="table-bit-not-header">
        <div>
          <SelectTamanoPagina
            value={pagination.pageSize}
            onChange={handleChangePageSize}
            disableBottomExcel={totalN === 0 || downloadingExcel}
            onClick={handleDownloadExcel}
          />
        </div>
      </div>
      {contextHolder}
      <Table
        loading={loading}
        rowKey={generateId()}
        bordered={false}
        scroll={{ x: 2000 }}
        columns={columns}
        dataSource={dataList}
        pagination={
          totalN > 0 && {
            ...pagination,
            onChange: (page, pageSize) => {
              setPagination((prev) => ({
                ...prev,
                current: page,
                total: totalN > 0 && totalN,
                pageSize: pageSize || prev.pageSize
              }));
            }
          }
        }
      />
    </div>
  );
};

TablaBitacoraNotificacion.propTypes = {
  mainFilters: PropTypes.shape({
    idProcesoElectoral: PropTypes.number,
    idAmbito: PropTypes.number,
    fechaInicio: PropTypes.shape({}),
    fechaFinal: PropTypes.shape({})
  }).isRequired,
  pagination: PropTypes.func.isRequired,
  setPagination: PropTypes.func.isRequired
};
